import script from "./Phone.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone.vue?vue&type=script&setup=true&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=0b06442e&lang=css"

const __exports__ = script;

export default __exports__